module.exports = __webpack_public_path__ + "static/media/home.8c442414.png";